var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28,
    fill: "#D9D9D9",
    fillOpacity: 0.1,
    stroke: "#EB6B63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 42C28.2044 42 27.4413 41.6576 26.8787 41.0481C26.3161 40.4386 26 39.612 26 38.75C26 37.888 26.3161 37.0614 26.8787 36.4519C27.4413 35.8424 28.2044 35.5 29 35.5C29.7956 35.5 30.5587 35.8424 31.1213 36.4519C31.6839 37.0614 32 37.888 32 38.75C32 39.612 31.6839 40.4386 31.1213 41.0481C30.5587 41.6576 29.7956 42 29 42ZM29 16C30.7062 16 32.0656 17.5742 31.9437 19.4227L31.25 29.9852C31.1656 31.2648 30.1812 32.25 29.0094 32.25C27.8281 32.25 26.8531 31.2648 26.7687 29.9852L26.075 19.4227C25.9344 17.5742 27.2937 16 29 16Z",
    fill: "#EB6B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.6814e49e55fa4cf6b6b78c662e38434d.svg";
export { ForwardRef as ReactComponent };